import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    grupoAlimentos: [],
  },

  getters: {
    getGrupoAlimentos: (state) => state.grupoAlimentos,

    getListaGrupoAlimentos: (state) => {
      const listaGrupoAlimentos = [];

      state.grupoAlimentos.forEach((grupo) => {
        listaGrupoAlimentos.push({
          grupoAlimentos: grupo.title,
          fk_idCatFrecuencia: null,
          fk_idCatGrupoAlimentos: grupo.id,
        });
      });

      return listaGrupoAlimentos;
    },
  },

  mutations: {
    SET_GRUPO_ALIMENTOS(state, grupoAlimentos) {
      state.grupoAlimentos = grupoAlimentos;
    },
  },

  actions: {
    async fetchGrupoAlimentos({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catGrupoAlimentos')
        .then((response) => {
          commit('SET_GRUPO_ALIMENTOS', response.data.data);
        });
    },
  },
};
